'use strict';

var RejectModalDirecitve = function RejectModalDirecitve() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/reject-modal.html'),
    controller: 'RejectModalController',
    link: function link($scope, element) {
      $scope.hideRejectModal = function () {
        element.modal('hide');
      };
    }
  };
};
RejectModalDirecitve.inject = [];
module.exports = RejectModalDirecitve;